import type { HttpClient } from "../http";
import type {
  CompanyPerformanceDTO,
  PricingRuleSlabDTO,
  SkuDTO,
} from "../types";

export function superAdminResource(http: HttpClient) {
  return {
    listPricingRules: () =>
      http.get<PricingRuleSlabDTO[]>("/super-admin/pricing-rules"),

    updatePricingRule: (
      id: number,
      body: Partial<PricingRuleSlabDTO>,
      recalculateSkus = true,
      resetAdminOverrides = false,
    ) =>
      http.put<PricingRuleSlabDTO>(
        `/super-admin/pricing-rules/${id}?recalculateSkus=${recalculateSkus}&resetAdminOverrides=${resetAdminOverrides}`,
        body,
      ),

    recalculateCatalogBaselines: (resetAdminOverrides = false) =>
      http.post<{
        recalculatedSkus: number;
        resetAdminOverrides: boolean;
        updatedByPhone: string;
      }>(
        `/super-admin/pricing-rules/recalculate-catalog?resetAdminOverrides=${resetAdminOverrides}`,
        {},
      ),

    resetSkuToBaseline: (skuId: number) =>
      http.post<SkuDTO>(`/super-admin/skus/${skuId}/reset-baseline`, {}),

    getCompanyPerformance: (start?: string, end?: string) => {
      const params = new URLSearchParams();
      if (start) params.set("start", start);
      if (end) params.set("end", end);
      const qs = params.toString();
      return http.get<CompanyPerformanceDTO>(
        `/super-admin/company-performance${qs ? `?${qs}` : ""}`,
      );
    },
  };
}
